module.exports = __webpack_public_path__ + "img/main.31589ac4.jpg";